module.exports = __webpack_public_path__ + "img/logo.128df252.svg";